const RATE_FIELDS = [
  { key: 'transactionsItemMo', label: 'Transactions', unit: '$/Item/mo' },
  { key: 'balanceCall', label: 'Balance', unit: '$/call' },
  { key: 'authOnce', label: 'Auth', unit: '$/Item once' },
  { key: 'recurringItemMo', label: 'Recurring', unit: '$/Item/mo' },
  { key: 'liabilitiesItemMo', label: 'Liabilities', unit: '$/Item/mo' },
  { key: 'investmentsHoldingsItemMo', label: 'Investments holdings', unit: '$/Item/mo' },
  { key: 'investmentsTxItemMo', label: 'Investments tx', unit: '$/Item/mo' },
  { key: 'txRefreshCall', label: 'Tx refresh', unit: '$/call' },
  { key: 'enrichPerThousand', label: 'Enrich', unit: '$/1k txns' },
];

export default function RatesPanel({ rates, onChange }) {
  const handleRate = (key, value) => {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed) || parsed < 0) return;
    const safeValue = key === 'stripePercent' ? Math.min(1, parsed) : parsed;
    onChange({ ...rates, [key]: safeValue });
  };

  return (
    <section className="chart-card economics-panel">
      <h2>Rate card: Plaid, Stripe & AI</h2>
      <p className="chart-hint">
        Baseline path: Transactions + Balance. Optional Auth is off by default per PCC-8; enable it
        on a profile only when modeling a future ACH flow. Transaction refreshes are explicit
        per-profile calls.
      </p>
      <div className="economics-form-grid">
        {RATE_FIELDS.map((field) => (
          <label key={field.key} className="economics-field">
            <span>
              {field.label} <span className="economics-field-unit">({field.unit})</span>
            </span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={rates[field.key]}
              onChange={(e) => handleRate(field.key, e.target.value)}
            />
          </label>
        ))}
      </div>
      <h3 className="economics-subheading">Stripe processing</h3>
      <p className="chart-hint">US card estimate per successful subscription charge (2.9% + $0.30 default).</p>
      <div className="economics-form-grid economics-form-grid-compact">
        <label className="economics-field">
          <span>
            Percent <span className="economics-field-unit">(decimal)</span>
          </span>
          <input
            type="number"
            min="0"
            max="1"
            step="0.001"
            value={rates.stripePercent ?? 0.029}
            onChange={(e) => handleRate('stripePercent', e.target.value)}
          />
        </label>
        <label className="economics-field">
          <span>
            Fixed fee <span className="economics-field-unit">($/charge)</span>
          </span>
          <input
            type="number"
            min="0"
            step="0.01"
            value={rates.stripeFixed ?? 0.3}
            onChange={(e) => handleRate('stripeFixed', e.target.value)}
          />
        </label>
      </div>
      <h3 className="economics-subheading">AI chat (quota + packs)</h3>
      <p className="chart-hint">
        Premium+ only. Included turns are an entitlement (cost in plan). Overage → auto-buy packs
        (CI-minutes style). Pack list &gt; vendor $/turn so overage is margin-positive.
      </p>
      <div className="economics-form-grid economics-form-grid-compact">
        <label className="economics-field">
          <span>
            Cost / turn <span className="economics-field-unit">($)</span>
          </span>
          <input
            type="number"
            min="0"
            step="0.001"
            value={rates.aiCostPerTurn ?? 0.04}
            onChange={(e) => handleRate('aiCostPerTurn', e.target.value)}
          />
        </label>
        <label className="economics-field">
          <span>
            Included turns (Premium) <span className="economics-field-unit">(/mo)</span>
          </span>
          <input
            type="number"
            min="0"
            step="1"
            value={rates.aiIncludedTurnsPremium ?? 40}
            onChange={(e) => handleRate('aiIncludedTurnsPremium', e.target.value)}
          />
        </label>
        <label className="economics-field">
          <span>
            Included turns (Enterprise) <span className="economics-field-unit">(/mo)</span>
          </span>
          <input
            type="number"
            min="0"
            step="1"
            value={rates.aiIncludedTurnsEnterprise ?? 100}
            onChange={(e) => handleRate('aiIncludedTurnsEnterprise', e.target.value)}
          />
        </label>
        <label className="economics-field">
          <span>
            Pack size <span className="economics-field-unit">(turns)</span>
          </span>
          <input
            type="number"
            min="1"
            step="1"
            value={rates.aiPackTurns ?? 100}
            onChange={(e) => handleRate('aiPackTurns', e.target.value)}
          />
        </label>
        <label className="economics-field">
          <span>
            Pack price <span className="economics-field-unit">($)</span>
          </span>
          <input
            type="number"
            min="0"
            step="0.5"
            value={rates.aiPackPrice ?? 8}
            onChange={(e) => handleRate('aiPackPrice', e.target.value)}
          />
        </label>
      </div>
    </section>
  );
}
